import { v4 as uuidv4 } from 'uuid';
import { MEDIA_TYPES } from '../../constants';

const DEFAULT_OPTIONS = {
  maxWidth: 240,
  maxHeight: 240,
  quality: 0.78,
  outputType: 'image/jpeg',
  background: '#ffffff',
};

export async function createImageThumbnail(file, options = {}) {
  if (!file || !file.type?.startsWith('image/')) return null;

  const opts = { ...DEFAULT_OPTIONS, ...options };
  const srcUrl = URL.createObjectURL(file);

  try {
    const source = await loadImageSource(srcUrl);
    const { width: srcW, height: srcH } = getSourceSize(source);

    if (!srcW || !srcH) {
      cleanupSource(source);
      URL.revokeObjectURL(srcUrl);
      return null;
    }

    const { width: dstW, height: dstH } = fitInside(srcW, srcH, opts.maxWidth, opts.maxHeight);

    const canvas = document.createElement('canvas');
    canvas.width = dstW;
    canvas.height = dstH;

    const ctx = canvas.getContext('2d');
    if (!ctx) {
      cleanupSource(source);
      URL.revokeObjectURL(srcUrl);
      return null;
    }

    if (opts.outputType === 'image/jpeg') {
      ctx.fillStyle = opts.background;
      ctx.fillRect(0, 0, dstW, dstH);
    }

    ctx.drawImage(source, 0, 0, dstW, dstH);

    const blob = await canvasToBlob(canvas, opts.outputType, opts.quality);
    cleanupSource(source);
    URL.revokeObjectURL(srcUrl);

    if (!blob) return null;

    const thumbnailUrl = URL.createObjectURL(blob);

    return {
      // blob,
      id: uuidv4(),
      thumbnailUrl,
      width: dstW,
      height: dstH,
      type: MEDIA_TYPES.IMAGE,
      name: file.name,
      // mimeType: blob.type || opts.outputType,
      // size: blob.size,
      // revoke: () => URL.revokeObjectURL(thumbnailUrl),
    };
  } catch {
    URL.revokeObjectURL(srcUrl);
    return {
      id: uuidv4(),
      name: file.name,
      type: MEDIA_TYPES.APPLICATION,
    };
  }
}

async function loadImageSource(srcUrl) {
  if (typeof createImageBitmap === 'function') {
    try {
      const response = await fetch(srcUrl);
      const blob = await response.blob();
      return await createImageBitmap(blob);
    } catch {
      // 2) fallback
    }
  }

  return await loadHtmlImage(srcUrl);
}

function loadHtmlImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.decoding = 'async';
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

function getSourceSize(source) {
  const width = source.width || source.naturalWidth || 0;
  const height = source.height || source.naturalHeight || 0;
  return { width, height };
}

function fitInside(srcW, srcH, maxW, maxH) {
  const ratio = Math.min(maxW / srcW, maxH / srcH, 1);
  return {
    width: Math.max(1, Math.round(srcW * ratio)),
    height: Math.max(1, Math.round(srcH * ratio)),
  };
}

function canvasToBlob(canvas, type, quality) {
  return new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob), type, quality);
  });
}

function cleanupSource(source) {
  if (source && typeof source.close === 'function') {
    source.close();
  }
}
